import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { KhenThuongAPI } from '../../services/feature-api';
import { PageShell, Icon, TrangThaiChip, NutXemQuyDinh, MAU_THE, fmtNgay, soNgayCon, nhanTinhTrang } from './khen-thuong-shared';

// /khenthuong/:ma — chi tiết 1 chiến dịch (bảng loai_khen_thuong). Chỉ Du lịch 2026 (coForm) có nút Đăng ký / Theo dõi.

const Khoi = ({ icon, title, children }) => (
  <div className="rounded-2xl bg-white border border-gray-200 shadow-sm px-4 py-3">
    <p className="flex items-center gap-1.5 text-[12px] font-bold text-gray-500 uppercase tracking-wide mb-1.5">
      <Icon name={icon} size={16} />{title}
    </p>
    {children}
  </div>
);

const Dong = ({ label, value, bold }) => (
  <div className="flex items-center justify-between py-1.5 border-b border-dashed border-gray-100 last:border-0">
    <span className="text-[13px] text-gray-500">{label}</span>
    <span className={`text-[13px] text-gray-900 ${bold ? 'font-black' : 'font-semibold'}`}>{value}</span>
  </div>
);

const KhenThuongChiTietPage = ({ accessToken, userInfo, onLogout, totalPoints, onRefreshPoints }) => {
  const { ma } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!accessToken || !ma) return;
    setLoading(true); setError('');
    const r = await KhenThuongAPI.getByMa(accessToken, ma);
    if (r.success) setItem(r.data);
    else setError(r.error || 'Không tìm thấy chương trình');
    setLoading(false);
  }, [accessToken, ma]);

  useEffect(() => { load(); }, [load]);

  const mo = item?.tinhTrang === 'mo';
  const daNop = !!item?.trangThaiCuaToi;
  const con = soNgayCon(item?.ketThucDk);
  const mau = MAU_THE[Math.max(0, (Number(item?.stt) || 1) - 1) % MAU_THE.length];

  return (
    <PageShell userInfo={userInfo} onLogout={onLogout} totalPoints={totalPoints} onRefreshPoints={onRefreshPoints} title={item?.ten || 'Khen thưởng'}>
      <div className="px-3 pt-3 space-y-3">
        {loading && <p className="text-center text-gray-400 text-sm py-8">Đang tải...</p>}
        {error && <div className="rounded-xl bg-red-50 border border-red-200 text-red-700 text-[13px] px-3 py-2">{error}</div>}

        {item && (
          <>
            <div className="rounded-2xl px-4 py-4 text-white shadow-md" style={{ background: mau }}>
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center justify-center min-w-[28px] h-7 px-2 rounded-full bg-white/25 text-[13px] font-black">
                  {String(item.stt ?? '').padStart(2, '0')}
                </span>
                <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold ${mo ? 'bg-white text-emerald-700' : 'bg-black/25 text-white'}`}>
                  <Icon name={mo ? 'lock_open' : 'schedule'} size={13} />{nhanTinhTrang(item.tinhTrang)}
                </span>
              </div>
              <h2 className="mt-2 text-[24px] font-black leading-tight drop-shadow">{item.ten}</h2>
              {item.ketThucDk && (
                <p className="mt-2 text-[13px] font-semibold bg-white/20 inline-flex items-center gap-1 rounded-full px-3 py-1">
                  <Icon name="alarm" size={15} />Hạn đăng ký {fmtNgay(item.ketThucDk)}
                  {mo && con >= 0 && <span className="font-black">· còn {con} ngày</span>}
                </p>
              )}
              <div className="mt-3 flex items-center justify-between">
                <span className="text-white/80 text-[12px]">Tình trạng của bạn</span>
                {daNop ? <TrangThaiChip trangThai={item.trangThaiCuaToi} size="lg" />
                       : <span className="rounded-full bg-white/20 px-3 py-1 text-[12px] font-bold">Chưa đăng ký</span>}
              </div>
            </div>

            {item.coForm && (
              <div className="grid grid-cols-2 gap-2">
                <button type="button" disabled={daNop || !mo} onClick={() => navigate('/khenthuong/du-lich-2026/dang-ky')}
                        className={`rounded-xl py-3 text-[13px] font-bold flex items-center justify-center gap-1 ${
                          daNop || !mo ? 'bg-gray-200 text-gray-500' : 'bg-red-600 text-white shadow-md active:bg-red-700'}`}>
                  <Icon name="edit_document" size={17} />{daNop ? 'Đã đăng ký' : 'Đăng ký + cam kết doanh số'}
                </button>
                <button type="button" onClick={() => navigate('/khenthuong/du-lich-2026/tinh-trang')}
                        className="rounded-xl py-3 text-[13px] font-bold flex items-center justify-center gap-1 bg-white border-2 border-red-600 text-red-700 active:bg-red-50">
                  <Icon name="track_changes" size={17} />Theo dõi tình trạng và kết quả
                </button>
              </div>
            )}

            <Khoi icon="checklist" title="Yêu cầu">
              <p className="text-[14px] text-gray-800 whitespace-pre-line">{item.yeuCau || 'Đang cập nhật'}</p>
            </Khoi>
            <Khoi icon="redeem" title="Quyền lợi">
              <p className="text-[14px] text-gray-800 whitespace-pre-line">{item.quyenLoi || 'Đang cập nhật'}</p>
            </Khoi>
            <Khoi icon="calendar_month" title="Thời gian">
              <Dong label="Đăng ký" value={`${fmtNgay(item.batDauDk)} → ${fmtNgay(item.ketThucDk)}`} bold />
              <Dong label="Xét duyệt" value={`${fmtNgay(item.batDauDuyet)} → ${fmtNgay(item.ketThucDuyet)}`} />
            </Khoi>
            <Khoi icon="groups" title="Số liệu">
              <div className="grid grid-cols-5 gap-1 text-center">
                {[['Dự kiến', item.duKien, 'text-gray-900'], ['Đăng ký', item.daDangKy, 'text-blue-700'], ['Chờ duyệt', item.choDuyet, 'text-amber-700'],
                  ['Đã duyệt', item.pheDuyet, 'text-emerald-700'], ['Thực nhận', item.thucNhan, 'text-violet-700']].map(([l, v, c]) => (
                  <div key={l} className="rounded-lg bg-gray-50 border border-gray-200 py-1.5">
                    <p className={`text-[18px] font-black leading-tight ${c}`}>{(Number(v) || 0).toLocaleString('vi-VN')}</p>
                    <p className="text-[9px] font-semibold text-gray-500 uppercase">{l}</p>
                  </div>
                ))}
              </div>
              {item.demSong && <p className="text-[10px] text-gray-400 mt-1.5">Số đăng ký / duyệt cập nhật trực tiếp từ hồ sơ đã nộp.</p>}
            </Khoi>
            {(item.nhomZalo || item.fileQuyDinh) && (
              <Khoi icon="link" title="Liên kết">
                <div className="py-1.5"><NutXemQuyDinh fileQuyDinh={item.fileQuyDinh} /></div>
                {item.nhomZalo && (
                  <a href={item.nhomZalo} target="_blank" rel="noreferrer" className="flex items-center gap-2 py-1.5 text-[14px] font-semibold text-blue-700">
                    <Icon name="forum" size={18} />Nhóm Zalo chương trình
                  </a>)}
              </Khoi>
            )}
          </>
        )}
      </div>
    </PageShell>
  );
};

export default KhenThuongChiTietPage;
